import React, { useState } from "react";
import { Share2, Check } from "lucide-react";

/**
 * ShareButton — copia al portapapeles el link OG del recurso para compartir
 * en WhatsApp/IG/Twitter con preview rico (imagen + título + descripción).
 *
 * En mobile usa Web Share API nativa. En desktop cae a clipboard.
 *
 * Props:
 *  - kind: "venue" | "route" | "coupon"
 *  - id: string del recurso
 *  - label: string opcional (default "Compartir")
 *  - className: clases extra tailwind
 */
export default function ShareButton({ kind, id, label = "Compartir", className = "", testid }) {
  const [copied, setCopied] = useState(false);

  const buildUrl = () => {
    // Public site URL if configured (production), else current origin (preview).
    const base =
      process.env.REACT_APP_PUBLIC_SITE_URL?.replace(/\/$/, "") ||
      window.location.origin.replace(/\/$/, "");
    return `${base}/api/og/${kind}/${id}`;
  };

  const handleShare = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const url = buildUrl();

    // Prefer native Web Share API (iOS/Android)
    if (navigator.share) {
      try {
        await navigator.share({ url });
        return;
      } catch {
        /* user cancelled — fall through to clipboard */
      }
    }

    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2200);
    } catch {
      // Last-resort fallback: prompt
      window.prompt("Copia el link para compartir:", url);
    }
  };

  return (
    <button
      type="button"
      onClick={handleShare}
      data-testid={testid || `share-${kind}-${id}`}
      className={`inline-flex items-center gap-2 border-2 border-[#FEBA01] text-[#FEBA01] font-display text-xs uppercase tracking-wide px-3 py-2 hover:bg-[#FEBA01] hover:text-black transition-colors ${className}`}
      aria-label={`Compartir ${kind}`}
    >
      {copied ? <Check size={14} /> : <Share2 size={14} />}
      {copied ? "¡Copiado!" : label}
    </button>
  );
}
